export default __webpack_public_path__ + "772c2044f4bf1da12e9fd122f4b3ca4c.svg";